import React from 'react';
import { 
  Wifi, 
  ChefHat, 
  Mountain, 
  Bed,
  Flame,
  Heart,
  Music, 
  Bath, 
  Home
} from 'lucide-react';

const ServicesSection = ({ currentContent }) => {
  const serviceIcons = [Wifi, ChefHat, Mountain, Bed, Flame, Heart, Music, Bath, Home];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-dancing">
            {currentContent.services.title}
          </h2>
          <p className="text-xl text-tilcara-orange font-medium mb-4">
            {currentContent.services.subtitle}
          </p>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {currentContent.services.humanSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {currentContent.services.list.map((service, index) => {
            const IconComponent = serviceIcons[index];
            return (
              <div key={index} className="text-center p-6 interactive-card bg-gray-50 rounded-xl">
                <div className="inline-flex items-center justify-center w-16 h-16 bg-tilcara-orange text-white rounded-full mb-4">
                  <IconComponent className="h-8 w-8" />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
